import {
    EVENTS_ENTRY
    //  ARTISTS_CONTACTS
} from '../../constants/actions';
// import { entryArtistSelector } from '../../selectors/events/timetable';

export function showEntry(entry) {
    return async dispatch => {
        dispatch({
            type: EVENTS_ENTRY.SHOW,
            entry
        });
    };
}

// const _contactFetched = (dispatch, getState, artistId, contactInfo) => {
//     if (entryArtistSelector(getState()) === artistId) {
//         dispatch({
//             type: ARTISTS_CONTACTS.FETCH_OK,
//             contact: contactInfo
//         });
//     }
// };

export const hideEntry = () => ({ type: EVENTS_ENTRY.HIDE });
